import { PopoverFloating } from '@components/core-ui/PopoverFloating';
import { routes } from '@routes';
import { useRef, useState } from 'react';

import { OrganizationsCell } from '../../styles/OrganizationsCell';
import { StyledLink } from '../../styles/StyledLink';
import type { TProps } from './types/TProps';
import { Link } from 'react-router-dom';

const MAX_VISIBLE_ORGANIZATIONS = 3;

export const OrganizationsPreview = ({ organizations }: TProps) => {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  if (organizations.length === 0) {
    return null;
  }

  const visibleOrganizations = organizations.slice(0, MAX_VISIBLE_ORGANIZATIONS);
  const hasMoreOrganizations = organizations.length > MAX_VISIBLE_ORGANIZATIONS;

  return (
    <div className="flex min-w-0 max-w-full flex-wrap items-center gap-2">
      {visibleOrganizations.map((organization) => (
        <OrganizationsCell key={organization.id} className="!m-0 max-w-48 min-w-0 shrink">
          <StyledLink
            className="block max-w-full overflow-hidden text-ellipsis whitespace-nowrap"
            to={routes.adminOrganizationDetails.make(organization.id)}
          >
            {organization.name}
          </StyledLink>
        </OrganizationsCell>
      ))}
      {hasMoreOrganizations ? (
        <button
          ref={triggerRef}
          type="button"
          aria-expanded={isOpen}
          aria-haspopup="dialog"
          aria-label={`View all ${organizations.length} organizations`}
          className="p-1.5 shrink-0 whitespace-nowrap text-sm font-medium text-link underline hover:text-accent focus:outline-none focus-visible:ring-2 focus-visible:ring-link"
          onClick={() => setIsOpen((open) => !open)}
        >
          View all {organizations.length}
        </button>
      ) : null}
      <PopoverFloating
        open={isOpen}
        onClose={() => setIsOpen(false)}
        anchorEl={triggerRef.current}
        placement="bottom-end"
        maxHeight={400}
        className="w-80 max-w-viewport-inset"
      >
        <div className="shrink-0 border-b border-border px-3 py-2 text-sm font-semibold text-foreground">
          Organizations ({organizations.length})
        </div>
        <ul className="m-0 min-h-0 flex-1 list-none overflow-y-auto p-1.5">
          {organizations.map((organization) => (
            <li key={organization.id}>
              <Link
                className="block overflow-hidden text-ellipsis whitespace-nowrap rounded px-2 py-1.5 text-sm text-foreground hover:bg-surface-muted hover:text-link hover:no-underline"
                to={routes.adminOrganizationDetails.make(organization.id)}
              >
                {organization.name}
              </Link>
            </li>
          ))}
        </ul>
      </PopoverFloating>
    </div>
  );
};
